import React from "react";

import { DropdownButton, MenuItem } from "react-bootstrap";

import HSGCard from "../../../../Components/HSGCard/HSGCard";

import Pagination from "../../../HSGPagination/HSGPagination";
import { DataphiGrid } from "dataphi-react-components/dist/Containers/Grid/DataphiGrid/DataphiGrid";

import "./Student.css";
import moment from "moment";
import Constants from "../../../../Phi/Constants";

class StudentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            inSearchString: "",

            defaultLimit: 10,
            defaultOffset: 0,
            defaultSortField: "name, class, section",
            defaultSortBy: "desc",
            defaultSearchString: ""
        };
    }

    componentWillMount() {
        this.props.getSchoolClasses();
        this.props.fetchStudentSearch(
            this.props.buildStudentHeader({ inOrganizationId: this.props.organizationId }, this.props.studentHeader)
        );
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        // if (nextProps.studentHeader !== this.props.studentHeader){
        //     this.props.fetchStudentSearch(this.props.buildStudentHeader({inOrganizationId: nextProps.organizationId}, nextProps.studentHeader))
        // }
    }

    showNext = where => {
        let { inLimit, inOffset } = this.props.studentHeader;
        let { studentTotal, studentHeader } = this.props;
        if (where === "prev") {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit;
            this.props.fetchStudentSearch(this.props.buildStudentHeader({ inOffset: newOffset }, studentHeader));
        } else {
            if (inOffset >= studentTotal || inOffset + inLimit >= studentTotal) {
                return;
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchStudentSearch(this.props.buildStudentHeader({ inOffset: newOffset }, studentHeader));
        }
    };

    _renderPagination = className => {
        const { studentHeader, studentList, studentTotal } = this.props;
        return studentList && studentList.length ? (
            <Pagination
                inOffset={studentHeader.inOffset}
                showNext={this.showNext}
                data={studentList}
                total={studentTotal}
                className={className}
            />
        ) : null;
    };

    search(param) {
        let inSearchString = param;
        this.props.fetchStudentSearch(
            this.props.buildStudentHeader(
                {
                    inSearchString: inSearchString,
                    inLimit: this.state.defaultLimit,
                    inOffset: this.state.defaultOffset
                },
                this.props.studentHeader
            )
        );
    }

    searchStudent = e => {
        const { inSearchString } = this.state;
        e.keyCode === 13 && this.search(inSearchString.trim().toLowerCase());
    };

    updateSearchBox = e => {
        e.target.value !== this.state.inSearchString && this.setState({ inSearchString: e.target.value });
    };

    _renderToolbar = () => {
        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="student-search-box-container">
                    <input
                        onChange={e => {
                            this.updateSearchBox(e);
                        }}
                        onKeyDown={e => {
                            this.searchStudent(e);
                        }}
                        placeholder="Type in Student Name or Admission No and Press Return "
                        className="student-input-search-box"
                        type="text"
                        value={this.state.inSearchString}
                    />
                </div>
            </div>
        );
    };

    formatData = data => {
        if (!!!data) {
            return [];
        } else {
            let genderMap = {
                M: "MALE",
                F: "FEMALE",
                O: "OTHER"
            };
            let newData = data.map((d, i) => {
                let d_object = {};
                d_object.studentname = d.name;
                d_object.studentId = d.student_id;
                d_object.uuid = d.uuid;
                d_object.dob = moment(d.dob).format(Constants.defaultDateFormat);
                d_object.gender = genderMap[d.gender];
                d_object.admission_number = d.admission_number;
                d_object.class = d.class;
                d_object.section = d.section;
                return d_object;
            });
            return newData;
        }
    };

    // getActions = (cell, row, unqIdentifier) => (
    //     <div className="center">
    //         <p onClick = {() => {this.props.openStudentProfile(row.studentId)}} style={{fontWeight: "bold", cursor: "pointer"}}>View Profile</p>
    //     </div>
    // )

    getActions = (cell, row, unqIdentifier) => (
        <div className="center">
            <p
                onClick={() => this.props.openStudentProfile(row.studentId)}
                style={{ fontWeight: "bold", cursor: "pointer" }}
            >
                <span
                    aria-hidden="true"
                    data-icon="\e913"
                    className="icon-next"
                ></span>
            </p>
        </div>
    );

    getTableHeader = () => {
        return [
            {
                dataField: "index",
                value: "Sl. No.",
                width: "25"
            },
            // {
            //     dataField: "uuid",
            //     value: "HSG ID",
            //     width: "130"
            // },
            {
                dataField: "admission_number",
                value: "ADMISSION NO.",
                width: "100"
            },
            {
                dataField: "studentname",
                value: "STUDENT NAME",
                width: "150"
            },
            {
                dataField: "class",
                value: "CLASS",
                width: "150"
            },
            {
                dataField: "section",
                value: "SECTION",
                width: "75"
            },
            {
                dataField: "gender",
                value: "GENDER",
                width: "75"
            },
            {
                dataField: "dob",
                value: "DOB",
                width: "75"
            },
            {
                value: "Actions",
                phiDataFormat: (a, b, c) => this.getActions(a, b, c),
                headerAlign: "center",
                width: "80"
            }
        ];
    };

    getData = (data = []) => {
        const rowData = data.reduce((newArr, dataElement, index) => {
            const newDataElement = {
                ...dataElement,
                index: this.props.studentHeader.inOffset + 1 + index
            };
            newArr.push(newDataElement);
            return newArr;
        }, []);
        return rowData;
    };

    addNewFilter = (val, field) => {
        const newFilter = {
            [field]: val
        };
        this.setState({ ...newFilter }, () => this.fetchNewFilteredList(true));
    };

    fetchNewFilteredList = newFilter => {
        // let startNode = this.props.currentProgram.billing ? this.props.startNodeMap[this.props.currentProgram.billing.id] : null
        const { selectedClass, selectedSection } = this.state;
        if (newFilter) {
            if (selectedSection && selectedClass) {
                this.props.fetchStudentSearch(
                    this.props.buildStudentHeader(
                        { inOffset: 0, inSearchString: "", inClass: selectedClass, inSection: selectedSection },
                        this.props.studentHeader
                    )
                );
            } else {
                this.props.fetchStudentSearch(
                    this.props.buildStudentHeader(
                        { inOffset: 0, inSearchString: "", inClass: selectedClass },
                        this.props.studentHeader
                    )
                );
            }
        } else {
            this.props.fetchStudentSearch(
                this.props.buildStudentHeader(
                    { sinOffset: 0, inSearchString: "", inClass: null, inSection: null },
                    this.props.studentHeader
                )
            );
        }
    };

    resetClassFilter = () => {
        this.setState({
            selectedClass: null,
            selectedSection: null,
        }, () => this.fetchNewFilteredList(false))
    }

    getClasses = (classes, selectedClass, ailment, isSmall) => {
        return (
            <div>
                <button key={"reset"} className="btn hsg-btn-warning right" onClick={() => this.resetClassFilter()}>
                    <span className="glyphicon glyphicon-refresh" aria-hidden="true"></span>
                </button>
                <div className="right" key={"section"}>
                    <DropdownButton
                        title={this.state.selectedSection || "Section"}
                        id="dropdown-for-section"
                        // className="max-drop-down-height"
                        onSelect={data => this.addNewFilter(data, "selectedSection")}
                    >
                        {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ? (
                            classes[selectedClass].map(section =>
                                this.state.selectedSection === section ? (
                                    <MenuItem key={section} eventKey={section} active>
                                        {section}
                                    </MenuItem>
                                ) : (
                                    <MenuItem key={section} eventKey={section}>
                                        {section}
                                    </MenuItem>
                                )
                            )
                        ) : (
                            <MenuItem>{"Please select a class"}</MenuItem>
                        )}
                    </DropdownButton>
                </div>
                <div className="right" key={"classes"}>
                    <DropdownButton
                        title={this.state.selectedClass || "Class"}
                        id="dropdown-for-class"
                        className="right"
                        onSelect={data => this.addNewFilter(data, "selectedClass")}
                    >
                        {Object.keys(classes).map(eachClass =>
                            this.state.selectedClass === eachClass ? (
                                <MenuItem key={eachClass} eventKey={eachClass} active>
                                    {eachClass}
                                </MenuItem>
                            ) : (
                                <MenuItem key={eachClass} eventKey={eachClass}>
                                    {eachClass}
                                </MenuItem>
                            )
                        )}
                    </DropdownButton>
                </div>
            </div>
        );
    };

    _renderStudentList = studentList =>
        studentList && studentList.length ? (
            <DataphiGrid
                bordered={false}
                trClassName={"trClassName"}
                data={this.getData(studentList)}
                keyField={"index"}
                tableHeaderColumn={this.getTableHeader()}
                remote={true}
                boadered
                tableHeaderClass="my-header-class"
                tableBodyClass="my-body-class"
                containerClass="my-container-class"
                tableContainerClass="hsg-table-individual-report"
                headerContainerClass="my-header-container-class"
                bodyContainerClass="my-body-container-class"
            />
        ) : (
            this.props.noDataAvailable("Found Nothing!!!")
        );

    render() {
        let { studentList } = this.props;

        return (
            <div className="container" style={{ marginTop: 20 }}>
                
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-10">
                    {this.getClasses(this.props.classes, this.state.selectedClass)}
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style = {{marginBottom:100}}>
                    <HSGCard hideHeader >
                        <div className="show-grid row" style = {{paddingBottom : '8rem'}}>
                            <div className="col-md-12 col-sm-12 col-xs-12">{this._renderToolbar()}</div>

                            <div
                                className="col-md-12 col-sm-12 col-xs-12 padding-5"
                                style={{ marginTop: 20, minHeight: 520 }}
                            >
                                {this._renderStudentList(this.formatData(studentList))}
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12 padding-10">
                                {this._renderPagination("hsg-dashboard-pagination-bottom right")}
                            </div>
                        </div>
                    </HSGCard>
                </div>
            </div>
        );
    }
}

export default StudentList;



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Student/StudentList.js